import {
    container,
    description,
    cardTitle,
    whiteColor,
    grayColor,
    successColor
} from "assets/jss/material-kit-pro-react.jsx";

import customCheckboxRadioSwitch from "../customCheckboxRadioSwitchStyle";

const signupPageStyle = theme => ({
    ...customCheckboxRadioSwitch,
    description,
    cardTitle: {
        ...cardTitle,
        color: whiteColor + "  !important"
    },
    container: {
        ...container,
        position: "relative",
        zIndex: "4",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: "50px"
        },
        "@media (max-width: 992px)": {
            paddingBottom: "0px",
        }
    },
    pageHeader: {
        color: whiteColor,
        border: "0",
        height: "100%",
        margin: "0",
        display: "block!important",
        padding: "120px 0",
        position: "relative",
        minHeight: "100vh",
        alignItems: "center",
        "&:before": {
            background: "rgba(45, 84, 47, 0.71) !important"
        },
        "&:before,&:after": {
            position: "absolute",
            zIndex: "1",
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: '""'
        },
        "@media (max-width: 992px)": {
            paddingTop: "100px",
            paddingBottom: "0px !important",
        }
    },
    form: {
        margin: "0"
    },
    cardHeader: {
        width: "auto",
        textAlign: "center"
    },
    socialLine: {
        marginTop: "1rem",
        textAlign: "center",
        padding: "0"
    },
    inputIconsColor: {
        color: grayColor[13]
    },
    textCenter: {
        textAlign: "center"
    },
    iconButtons: {
        marginRight: "3px !important",
        marginLeft: "3px !important"
    },
    block: {
        color: "inherit",
        padding: "0.9375rem",
        fontWeight: "500",
        fontSize: "12px",
        textTransform: "uppercase",
        borderRadius: "3px",
        textDecoration: "none",
        position: "relative",
        display: "block"
    },
    inlineBlock: {
        display: "inline-block",
        padding: "0px",
        width: "auto"
    },
    blockList: {
        display: "block !important",
    },
    list: {
        marginBottom: "0",
        padding: "0",
        marginTop: "0"
    },
    left: {
        float: "left!important",
        display: "block",
        "&,& *,& *:hover,& *:focus": {
            color: whiteColor + "  !important"
        }
    },
    right: {
        padding: "15px 0",
        margin: "0",
        float: "right",
        "&,& *,& *:hover,& *:focus": {
            color: whiteColor + "  !important"
        }
    },
    icon: {
        width: "18px",
        height: "18px",
        top: "3px",
        position: "relative"
    },
    footer: {
        position: "absolute",
        width: "100%",
        background: "transparent",
        bottom: "0",
        color: whiteColor,
        zIndex: "2",
        "@media (max-width: 992px)": {
            position: "relative",
        }
    },
    marginBottom: {
        marginBottom: "10px",
    },
    contentCenter: {
        margin: "0 auto",
        display: "table",
        "& > a": {
            color: successColor[0]
        }
    },
    loginButton: {
        border: "1px solid",
        borderColor: successColor[0],
        lineHeight: "0.333",
    },
    greenText: {
        color: successColor[0],
    },
    inlineUl: {
        display: "inline-block",
        "& li": {
            paddingTop: "0px",
            paddingBottom: "0px"
        },
        "& li a": {
            paddingTop: "0px",
            paddingBottom: "0px"
        },
    },
    marginBottom10: {
        marginBottom: "20px"
    },
    textLeft: {
        textAlign: "left"
    },
    font30: {
        fontSize: "30px"
    },
    font20: {
        fontSize: "20px"
    },
    fontItalic: {
        fontStyle: "italic"
    },
    fontNormal: {
        fontStyle: "normal"
    },
    cardHeaderText: {
        fontSize: "25px",
        fontWeight: '700'
    },
    height76vh: {
        "@media (min-width: 992px)": {
            height: "76vh",
        }
    },
    transform50: {
        "@media (min-width: 992px)": {
            transform: "translate(0%, 50%);"
        }
    },
    smallScreen60vh: {
        "@media (max-width: 992px)": {
            height: "60vh"
        }
    },
    transform10: {
        "@media (max-width: 992px)": {
            transform: "translate(0%, 10%)"
        }
    }
});

export default signupPageStyle;
